import { CtaButton } from '@tkww/orion-web-ds-action';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { Input } from '@tkww/orion-web-ds-input';
import BlankButton from '@xo-union/component-blank-button';
import { compose } from '@xo-union/react-css-modules';
import { FormColumn, FormRow } from '@xo-union/tk-component-form-grid';
import { useAtom } from 'jotai';
import React, { type ChangeEvent, type KeyboardEvent } from 'react';
import { searchTextDisplayAtom } from '../atoms';
import Styles from './styles.scss';

const classes = compose({
	input: Styles.input,
	label: Styles.label,
});

interface Props {
	handleClear: () => void;
	setSearchText: (content: string | undefined) => void;
}

const SearchBar = ({ handleClear, setSearchText }: Props) => {
	const [search, setSearch] = useAtom(searchTextDisplayAtom);
	const handleClick = () => setSearchText(search);
	const handleOnChange = (e: ChangeEvent<HTMLInputElement>) =>
		setSearch(e.target.value);

	const handleEnter = (e: KeyboardEvent) => {
		if (e.key === 'Enter') {
			handleClick();
		}
	};

	return (
		<FormRow className={Styles.formRow}>
			<FormColumn className={Styles.formColumn}>
				<div className={Styles.buttonGroup}>
					<Input
						classes={classes}
						label="Search reviews"
						name="Search reviews"
						value={search}
						onChange={handleOnChange}
						onKeyDown={handleEnter}
					/>
					{search.length > 0 && (
						<BlankButton
							className={Styles.iconContainer}
							onClick={handleClear}
							data-testid="clear-button"
						>
							<Icon
								size="md"
								name="close-circle"
								className={Styles.icon}
								aria-label="Clear input"
							/>
						</BlankButton>
					)}
				</div>
				<CtaButton
					className={Styles.button}
					aria-label="search"
					styleType="tertiary"
					onClick={handleClick}
					type="button"
					iconName="magnifier"
					size="lg"
				/>
			</FormColumn>
		</FormRow>
	);
};

export { SearchBar };
